<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >管理员 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.title"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >邮箱号 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.title"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >操作时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom:10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom:10px"
              >重置</el-button
            >
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                type="primary"
                size="medium"
                @click="batch([...selectedRowKeys], 1)"
                >批量审核</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleDetails(row)"
          >详情</el-button
        >
        <el-button
          v-if="row.state == 1"
          type="text"
          size="mini"
          @click="batch(row.id, 2)"
          >审核</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      title="审核"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form
        ref="form"
        :defaults.sync="defaults"
        v-model="form"
        :option="formOption"
      >
        <!-- <template slot="details"> </template> -->

        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            :loading="showLoadingForm"
            @click="submit(form)"
            >确定</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  manageList,
  manageAudi,
  batchAudi,
  commitList,
} from "@/api/examine/manage";
import dayjs from "dayjs";
export default {
  name: "index",
  data() {
    return {
      defaults: {},
      searchData: {
        title: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "操作时间",
            prop: "createTime",
          },
          {
            label: "操作人",
            prop: "fullName",
          },
          {
            label: "角色权限",
            prop: "roleName",
          },
          {
            label: "邮箱",
            prop: "email",
          },
          {
            label: "操作模块",
            prop: "operateMenu",
          },
          {
            label: "操作名称",
            prop: "operateName",
          },
          {
            label: "IP",
            prop: "ip",
          },
        ],
      },

      dialogVisible: false,
      form: {
        state: 2,
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "审核操作",
            prop: "state",
            type: "radio",
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
            dicData: [
              {
                value: 2,
                label: "同意",
              },
              {
                value: 3,
                label: "拒绝",
              },
            ],
          },
          {
            label: "拒绝原因",
            prop: "reason",
            type: "textarea",
            span: 24,
            row: true,
            display: false,
            minRows: 3,
            maxlength: 200,
            // rules: [
            //   {
            //     required: true,
            //     message: "请输入",
            //     trigger: "blur",
            //   },
            // ],
          },
        ],
      },
      delId: "",
      delType: "", //1批量 2 单个
    };
  },
  watch: {
    "form.state"(val) {
      if (val == 3) {
        console.log(this.defaults, "this.defaultsthis.defaults");
        this.defaults.reason.display = true;
      } else {
        this.defaults.reason.display = false;
      }
    },
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      manageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        details: "",
        id: "",
      };
      this.dialogVisible = true;
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //编辑
    async handleEdit(row) {
      console.log(row);
      this.form.id = row.id;
      this.dialogVisible = true;
      this.form = { ...row, details: row.content };
      console.log(this.form, "this.formthis.form");
    },
    //审核
    batch(row, type) {
      if (type == 1) {
        if (!row.length) {
          this.$message.error("至少选择一个");
          return;
        }
      }
      this.delType = type;
      this.delId =
        type == 1 ? this.selectedRowKeys.map((item) => item.id) : row;
      this.dialogVisible = true;
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          if (this.delType == 1) {
            batchAudi({
              ids: this.delId,
              ...form,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success("审核成功!");
                this.$refs.crud.toggleSelection();
                this.onLoad();
                this.dialogVisible = false;
              }
              this.showLoadingForm = false;
            });
          } else if (this.delType == 2) {
            manageAudi({
              id: this.delId,
              ...form,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success("审核成功!");
                this.$refs.crud.toggleSelection();
                this.onLoad();
                this.dialogVisible = false;
              }
              this.showLoadingForm = false;
            });
          }
        }
      });
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //详情
    handleDetails(row) {
      this.$router.push({
        path: "/examine/create",
        query: {
          id: row.id,
          type: "view",
        },
      });
    },
  },
};
</script>

<style scoped></style>
